import PersonalApiKeysTableExpiresAtCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/ExpiresAtCell";
import PersonalApiKeysTableIssuesCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/IssuesCell";
import PersonalApiKeysTableKeyIdCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/KeyIdCell";
import PersonalApiKeysTableLastUsedCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/LastUsedCell";

import { PERSONAL_API_KEYS_COLUMN_ID } from "../constants";
import PersonalApiKeysTableDropdownCell from "./DropdownCell";
import PersonalApiKeysTableNameCell from "./NameCell";

export const PERSONAL_API_KEYS_TABLE_CELLS = {
  [PERSONAL_API_KEYS_COLUMN_ID.NAME]: PersonalApiKeysTableNameCell,
  [PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: PersonalApiKeysTableKeyIdCell,
  [PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: PersonalApiKeysTableExpiresAtCell,
  [PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: PersonalApiKeysTableLastUsedCell,
  [PERSONAL_API_KEYS_COLUMN_ID.ISSUES]: PersonalApiKeysTableIssuesCell,
  [PERSONAL_API_KEYS_COLUMN_ID.DROPDOWN]: PersonalApiKeysTableDropdownCell,
};
